export const ghgReportBaseUrl =
  'https://backend.ghg.ge3s.org/api/report/get_reports';

export const siReportUrl =
  'https://backend.si.ge3s.org/api/report/';

export const ghgOnboard =
  'https://backend.ghg.ge3s.org/api/user/onboard-data';

const toBearer = (rawToken) => {
  if (!rawToken) return undefined;

  const token = rawToken
    .trim()
    .replace(/^bearer\s+/i, '')
    .replace(/^bear\s+/i, '');

  return token ? `Bearer ${token}` : undefined;
};

const buildHeaders = (rawAuthToken, rawSsoToken) => {
  const headers = {
    Accept: 'application/json'
  };

  const authHeader =
    toBearer(rawAuthToken) || toBearer(rawSsoToken);

  if (authHeader) {
    headers.Authorization = authHeader;
  }

  if (rawSsoToken) {
    headers['x-sso-token'] = rawSsoToken;
    headers.ssoToken = rawSsoToken;
  }

  return headers;
};

const safeStringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

const getLocalAuth = () => ({
  token: localStorage.getItem('token'),
  ssoToken: localStorage.getItem('ssoToken')
});

const getOrganizationId = async (token, ssoToken) => {
  try {
    const res = await fetch(ghgOnboard, {
      method: 'GET',
      headers: buildHeaders(token, ssoToken)
    });

    if (!res.ok) {
      console.log(res);
      return 'no organization found';
    }

    const data = await res.json();

    return (
      data?.organization?.id ||
      'no organization found'
    );
  } catch {
    return 'no organization found';
  }
};

export const siReportCollector = async (initialData) => {
  if (initialData?.content) {
    return initialData;
  }

  const { token, ssoToken } = getLocalAuth();

  try {
    const res = await fetch(siReportUrl, {
      method: 'GET',
      headers: buildHeaders(token, ssoToken)
    });

    if (!res.ok) {
      return {
        title: 'si report data',
        content: ''
      };
    }

    const data = await res.json();

    return {
      title: 'si report data',
      content: safeStringify(data)
    };
  } catch {
    return {
      title: 'si report data',
      content: ''
    };
  }
};

export const ghgReportCollector = async (initialData) => {
  if (initialData?.content) {
    return initialData;
  }

  const { token, ssoToken } = getLocalAuth();

  const organizationId = await getOrganizationId(
    token,
    ssoToken
  );

  const ghgReportUrl =
    `${ghgReportBaseUrl}?organizationId=${encodeURIComponent(
      organizationId
    )}&reportType=final`;

  try {
    const res = await fetch(ghgReportUrl, {
      method: 'GET',
      headers: buildHeaders(token, ssoToken)
    });

    if (!res.ok) {
      return {
        title: 'ghg report data',
        content: ''
      };
    }

    const data = await res.json();

    return {
      title: 'ghg report data',
      content: safeStringify(data)
    };
  } catch {
    return {
      title: 'ghg report data',
      content: ''
    };
  }
};

/**
 * Fetches report data directly from the SI or GHG backend Copilot endpoint.
 * Use this when you have the specific reportId and authToken available,
 * for a targeted, secure, single-report fetch.
 */
export const fetchBackendReportData = async (
  backendUrl,
  reportId,
  toolType,
  token
) => {
  try {
    const baseUrl = backendUrl.replace(/\/$/, '');
    const response = await fetch(`${baseUrl}/api/report/copilot/${reportId}`, {
      headers: {
        'Authorization': toBearer(token) || `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.error('Failed to fetch report from backend', await response.text());
      return undefined;
    }

    const data = await response.json();
    const rawReport = data.report || data;

    return {
      title: toolType === 'si' ? 'si report data' : 'ghg report data',
      content: safeStringify(rawReport)
    };
  } catch (error) {
    console.error('Error fetching backend report data:', error);
    return undefined;
  }
};